const signup = {
  invalidToken: 'אסימון הזמנה לא חוקי. אנא בדוק את הקישור או בקש הזמנה חדשה.',
  invitationAccepted: 'ההזמנה התקבלה בהצלחה. ברוך הבא!',
  unknownError: 'אופס! משהו השתבש.',
  conflictEmailOrPhone: 'כתובת האימייל או מספר הטלפון כבר בשימוש על ידי מודרטור אחר',
  signupTitle: 'הצטרף לצוות שלך!',
  submitBtn: 'הצטרף עכשיו',
  signupSuccessful: 'נרשמת בהצלחה ל-Moovex!',
  signupFailed: 'משהו השתבש. אנא נסה שוב או צור קשר עם michael@moovex.com',
  backToLogin: 'המשך להתחברות',
  phoneInvalid: 'מספר הטלפון אינו חוקי.',
  firstName: 'שם פרטי',
  lastName: 'שם משפחה',
  phone: 'טלפון',
  email: 'אימייל',
  createPassword: 'צור סיסמה',
  confirmPassword: 'אשר סיסמה',
  success: {
    redirectIn: 'You will be redirected in ',
    seconds: ' seconds',
  },
};

export default signup;
